'use client';

import './sac-list-spotlight.scss';

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getRandomChildren } from '@sola/proxy-sdk/children.js';
import { ChildAvailabilityItem } from '@sola/schema/dotcom/children/child.js';
import { SacFilterProps } from '@sola/schema/lib/schema.js';
import { getHeaderDisplayLevel } from '@sola/utils/assembly.js';

import { FeatureBase } from '../../../molecules/feature-base/feature-base';
import { SacCard } from '../../../molecules/sac-card/sac-card';
import { getBaseSizeProps } from '../../../utils/text-utils';

export const SacSpotlight: React.FC<SacFilterProps> = ({
  seoLevel = 2,
  title,
  body,
  ...props
}) => {
  const { t } = useTranslation(['common', 'bio']);
  const [childData, setChildData] = useState<ChildAvailabilityItem>();

  const headerDisplayLevel = getHeaderDisplayLevel(seoLevel);

  const { mergeFieldData: { richmixChildData } = {} } = props || {};

  useEffect(() => {
    if (richmixChildData) {
      setChildData(richmixChildData);
      return;
    }

    const getChildData = async () => {
      const response = await getRandomChildren();
      setChildData(response?.children[0]);
    };

    getChildData();
  }, []);

  return (
    <section className="SacListSpotlight component">
      <div className="container md:grid flex flex-col md:grid-cols-2 items-center gap-comfy-xl">
        <div className="flex flex-col gap-comfy-sm md:gap-comfy-lg">
          <FeatureBase
            {...getBaseSizeProps(headerDisplayLevel)}
            seoLevel={seoLevel}
            titleSize={seoLevel === 1 ? 'xxl' : 'xl'}
            title={title}
            body={body}
            className="pb-comfy-sm"
            variantResponsive
            inline
            primaryCTA={
              childData && {
                title: t('bio:title', {
                  childName: childData.name.preferred,
                }).replace(/[!.?,:;]/g, ''),
                link: `/sponsor-a-child/child-bio?gid=${childData.globalId}&source=${childData.sourceCode}`,
              }
            }
          />
        </div>
        <aside className="SacListSpotlight__child-container w-full">
          {childData && <SacCard {...childData} />}
        </aside>
      </div>
    </section>
  );
};
